// frontend/src/auth/ForgotPassword.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    // Validación básica
    if (!email || !email.includes('@')) {
      setError('Por favor ingresa un correo electrónico válido');
      setLoading(false);
      return;
    }

    try {
      console.log('📧 Solicitando recuperación para:', email);

      const response = await fetch(API_ENDPOINTS.forgotPassword, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al enviar el código');
      }

      console.log('✅ Código enviado exitosamente');
      setSuccess(data.message);

      // Esperar 2 segundos y redirigir a la página de reseteo
      setTimeout(() => {
        navigate('/reset-password', { 
          state: { email } 
        });
      }, 2000);

    } catch (err) {
      console.error('❌ Error:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-overlay" onClick={handleBack} />
      
      <div className="forgot-password-modal">
        <button className="close-button" onClick={handleBack}>
          ✕
        </button>

        <div className="modal-header">
          <div className="icon-circle">
            <svg className="lock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="5" y="11" width="14" height="10" rx="2" ry="2" strokeWidth="2"/>
              <path d="M7 11V7a5 5 0 0110 0v4" strokeWidth="2"/>
            </svg>
          </div>
          <h2 className="modal-title">¿Olvidaste tu contraseña?</h2>
          <p className="modal-subtitle">
            No te preocupes, te enviaremos un código de verificación
          </p>
        </div>

        {error && (
          <div className="alert alert-error">
            <span className="alert-icon">⚠️</span>
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            <span className="alert-icon">✅</span>
            <span>{success}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="form-group">
            <label htmlFor="email">Correo electrónico</label>
            <div className="input-wrapper">
              <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeWidth="2"/>
                <polyline points="22,6 12,13 2,6" strokeWidth="2"/>
              </svg>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="correo@ejemplo.com"
                required
                disabled={loading}
                autoFocus
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Enviando código...
              </>
            ) : (
              <>
                <svg className="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M22 2L11 13" strokeWidth="2"/>
                  <path d="M22 2L15 22L11 13L2 9L22 2Z" strokeWidth="2"/>
                </svg>
                Enviar código de recuperación
              </>
            )}
          </button>
        </form>

        <div className="info-box">
          <div className="info-item">
            <span className="info-icon">📧</span>
            <span>Recibirás un código de 6 dígitos</span>
          </div>
          <div className="info-item">
            <span className="info-icon">⏱️</span>
            <span>El código expira en 30 minutos</span>
          </div>
          <div className="info-item">
            <span className="info-icon">🔒</span>
            <span>Proceso 100% seguro</span>
          </div>
        </div>

        <div className="back-to-login">
          <span onClick={handleBack} className="back-link">
            ← Volver al inicio de sesión
          </span>
        </div>
      </div>
    </div>
  );
}